<template lang="pug">
include ../../utils/picture.pug
include ../../utils/icon-btn.pug
include ../../utils/text.pug

article.catalog-item.trs
  a.catalog-item__top.clr-blue-7.t-tdn(:href='item.url')
    .media-obj.catalog-item__img
      picture
        img(:src='item.image' alt='')
    +text({
      type: `h3`,
      className: `catalog-item__title`,
      text: '{{item.title}}'
    })
    p.t-md.catalog-item__description(v-html="item.description")

  .catalog-item__bottom
    span.catalog-item__price(v-if="item.price > 0")
      span.clr-grey-4 Цена
      span.clr-blue-6.trs '{{item.price}}'

    button.catalog-item__price(v-if="item.price <= 0" @click="showModal")
      span.clr-grey-4 Цена
      span.clr-blue-6.trs По&nbsp;запросу

    button.catalog-item__btn.clr-grey-4.trs(v-if="!inCompare" type=`button` @click="addToCompare") Сравнить
    a.catalog-item__btn.clr-grey-4.trs.catalog-item__in-compare(v-if="inCompare" type=`button` href='/compare/') В сравнении

    .catalog-item__cart-buttons-wraper
      button.icon-btn.t-tdn.trs.catalog-item__cart(
        v-if="!inBasket"
        type=button
        v-on:click="addToBasket"
      ) В корзину
        +picture('', { svgName: `i-list`, isSVG: true, basePathParam: '/local/templates/renaissance/layout/dist/'})
      button.icon-btn.t-tdn.trs.catalog-item__cart.catalog-item__cart_inbasket(
        v-if="inBasket"

        type=button
        title="В корзине"
      ) В корзине
        +picture('', { svgName: `i-list`, isSVG: true, basePathParam: '/local/templates/renaissance/layout/dist/'})
</template>

<script>
  import store from '~/js/store'
  const catalogItem = {
    data() {
      return {
      }
    },
    props: {
      item: {
        type: Object
      },
    },
    components: {
    },
    errors: [],
    computed: {
      inBasket() {
        let productsIds
        productsIds = store.getters.getProductInBasket(this.item.id)
        return productsIds.length > 0  ? true: false
      },
      inCompare() {
        let isCompare
        isCompare = store.getters.getCompareIds().filter(productId => parseInt(productId) === parseInt(this.item.id))

        return isCompare.length > 0 ? true : false
      }
    },
    methods: {
      showModal() {
        showPriceGetPopup(this.item.id)
      },
      addToBasket() {
        addToBasket(this.item.id)
      },
      addToCompare() {
        store.dispatch('addToCompare', parseInt(this.item.id))
      },
    }
  }

  export default catalogItem
</script>
